import { Container, styled } from "@mui/material";
import { NavBar } from "components/NavBar";
import { SideBar } from "components/SideBar";
import { useAuthStatus } from "helpers/useAuthStatus";
import { AssignmentManagementSwitch } from "pages/AssignmentManagement";
import { LandingPage } from "pages/Landing";
import { MetricsPage } from "pages/Metrics";
import { PeopleSwitch } from "pages/People";
// import { StudentResultSwitch } from "pages/Result";
// import { ResultPage } from "pages/Result/ResultPage";
import { ResultPage } from "pages/Result/ResultPage";
import { StudentGroupPageSwitch } from "pages/StudentGroup";
import { Redirect, Route, Switch, useLocation } from "react-router-dom";
import { errorRoutes, routes } from "routes";
import { StudentHomeDashboardPage } from "./StudentHomeDashboardPage";

const PREFIX = "HomeSwitch";

const classes = {
	content: `${PREFIX}-content`,
	container: `${PREFIX}-container`,
	paper: `${PREFIX}-paper`,
};

const Root = styled("div")(({ theme }) => ({
	[`& .${classes.content}`]: {
		display: "flex",
		paddingTop: 56,
		height: "100vh",
		[`${theme.breakpoints.up("xs")} and (orientation: landscape)`]: {
			paddingTop: 48,
		},
		[theme.breakpoints.up("sm")]: {
			paddingTop: 64,
		},
	},

	[`& .${classes.container}`]: {
		overflow: "auto",
		paddingTop: theme.spacing(2),
		paddingBottom: theme.spacing(2),
	},

	[`& .${classes.paper}`]: {
		padding: theme.spacing(2),
		display: "flex",
		overflow: "auto",
		flexDirection: "column",
	},
}));

export const StudentHomeSwitch = (): JSX.Element => {
	const location = useLocation();
	const { role, isLoading } = useAuthStatus();

	if (isLoading) {
		return <NavBar />;
	}

	if (role === "unauthenticated") {
		if (location.pathname === routes.path) {
			return <LandingPage />;
		}
		return <Redirect to={routes._.signIn.path} from={location.pathname} />;
	}

	return (
		<Root>
			<NavBar />

			<div className={classes.content}>
				<SideBar />

				{/* Pages */}
				<Container maxWidth={false} className={classes.container}>
					<Switch>
						<Route path={routes.path} exact>
							<StudentHomeDashboardPage />
						</Route>

						<Route path={routes._.people.path}>
							<PeopleSwitch />
						</Route>

						<Route path={routes._.assignments.path}>
							<AssignmentManagementSwitch />
						</Route>

						<Route path={routes._.groups.path}>
							<StudentGroupPageSwitch />
						</Route>

						<Route path={routes._.metrics.path}>
							<MetricsPage />
						</Route>

						<Route path={routes._.result.path}>
							<ResultPage />
						</Route>

						<Route>
							<Redirect to={errorRoutes._.error.path} />
						</Route>
					</Switch>
				</Container>
			</div>
		</Root>
	);
};
